import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BavelLogsModule } from '@logs/bavel-logs.module';

import { TranslationService } from './services/translation.service';
import { TranslationManagerService } from './services/translation-manager.service';

@NgModule({
    imports: [
        CommonModule,
        BavelLogsModule
    ],
    declarations: [],
    providers: [
        TranslationService,
        TranslationManagerService
    ]
})
export class BavelGlobalizationModule { }
